<template>
    <div class="product-configuration">
      <div class="container">
        <StorePopup v-if="phone" @update-phone="reloadPhone"/>
        <PricePopup v-if="phone"/>
        <TakeBackPopup/>

        <div class="product-name-mobile" v-if="phone">
          <h1>{{ phone.name }}</h1>
          <p class="attributes">
            <span class="storage" v-if="currentStorage">{{ currentStorage.toLowerCase() }}</span>
            <span class="color"><i :style="{ backgroundColor: '#' + currentColor }"></i>{{ phone.defaults.color.nom.toLowerCase() }}</span>
          </p>
        </div>

        <Pictures :loading="loading"/>
        <Configuration :loading="loading" :product="query.id"/>
        <Sticky/>
        <Accordion v-if="phone"/>

      </div>
  </div>
</template>

<script>
import Sticky from './components/Sticky'
import Pictures from './components/Pictures'
import StorePopup from './components/StorePopup'
import PricePopup from './components/PricePopup'
import Configuration from './components/Configuration'
import TakeBackPopup from './components/TakeBackPopup'
import Accordion from './components/accordion/Accordion'
import RelatedProducts from './components/related/RelatedProducts'

import {mapActions, mapState} from 'vuex'

export default {
  name: 'AppSingleProduct',
  data () {
    return {
      loading: true,
      query: {
        id: null,
        color: {
          id: null
        },
        storage: {
          capacite: null,
          unit: null
        },
        hasInsurance: true,
        hasSubscription: true
      }
    }
  },
  mounted() {
    const mountPoint = document.getElementById('single-phone')
    this.query.id = parseInt(mountPoint.getAttribute('data-id'))
    this.query.color.id = parseInt(mountPoint.getAttribute('data-color-id'))
    const storage = mountPoint.getAttribute('data-storage').split('-')
    if(storage){
      this.query.storage = {
        capacite: storage[0],
        unit: storage[1]
      }
    }
  },
  computed: {
    ...mapState({
      phone: state => state.phone.item
    }),
    id () {
      return this.query.id
    },
    currentColor () {
      let currentColor = 'FFFFFF'

      this.phone.colors.forEach((color) => {
        if(color.id === this.phone.defaults.color.id) currentColor = color.hex
      })

      return currentColor
    },
    currentStorage () {
      if(this.phone.defaults.storage){
        return this.phone.defaults.storage.capacite + ' ' + this.phone.defaults.storage.unit
      }

      return null
    }
  },
  methods: {
    ...mapActions('phone', ['getPhone', 'getInsurances']),
    ...mapActions('providers', ['getProviders']),
    refreshPhone () {
      this.getPhone(this.query).then(() => {
        this.getInsurances().then(() => {
          this.getProviders().then(() => {
            this.loading = false
          })
        })
      })
    },
    reloadPhone() {
      setTimeout(() => {
        this.refreshPhone()
      }, 400)
    }
  },
  watch: {
    id () {
      this.refreshPhone()
    }
  },
  components: {
    Sticky,
    Pictures,
    Accordion,
    StorePopup,
    PricePopup,
    Configuration,
    TakeBackPopup,
    RelatedProducts
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/tools/*';
@import '../../scss/mixins/*';

.product-configuration{
  .container{
    display: grid;
    grid-template-columns: 1fr 590px;
    grid-column-gap: 20px;
    padding-bottom: 0;

    @include responsive(mobile) {
      display: block;
    }

    .product-name-mobile{
      display: none;
      margin-bottom: 20px;

      @include responsive(mobile) {
        display: block;
      }

      h1{
        display: block;
        width: 100%;
        text-align: center;
        font-weight: $fontSemiBold;
        font-size: px2rem(24px);
        line-height: px2rem(35px);
      }

      p{
        display: inline-block;
        width: 100%;
        font-size: px2rem(14px);
        line-height: px2rem(20px);
        color: rgba($black, 0.8);
        text-transform: capitalize;
        text-align: center;

        &.attributes{
          text-transform: capitalize;
          margin: 3px 0;

          span.storage, span.color{
            display: inline-block;
            height: 24px;
            line-height: 20px;
            padding: 0 5px;
            margin: 0 3px 0 0;
            border: 2px solid rgba($black, 0.1);
            font-weight: $fontBold;
            vertical-align: middle;
            @include box-sizing();
            @include radius(3px);
          }

          span.color{
            i{
              display: inline-block;
              width: 8px;
              height: 8px;
              margin-right: 4px;
              vertical-align: middle;
              @include transform(translateY(-1px));
              @include radius(100%);
            }
          }
        }
      }
    }
  }
}
</style>
